import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { titleCase } from "change-case-all";
import { tableCellClasses } from "@mui/material/TableCell";

import { colors } from "../../../css components/Style";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: colors.iconColor,
    color: "#fff",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    backgroundColor: "#F9F9F9",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function TableStats({ data, fields }) {
  return (
    <TableContainer
      sx={{ maxHeight: 440, borderRadius: "10px" }}
      component={Paper}
    >
      <Table stickyHeader sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            {fields?.[data.channel_name]?.map(
              (key) =>
                key.display && (
                  <StyledTableCell>
                    {titleCase(key?.name.replace(/_/g, " "))}
                  </StyledTableCell>
                )
            )}
          </TableRow>
        </TableHead>

        <TableBody>
          {data.stats_data.map((row, index) => (
            <StyledTableRow key={index}>
              {fields?.[data.channel_name]?.map(
                (field, colIndex) =>
                  field.display && (
                    <StyledTableCell component="th" scope="row">
                      {row[field?.name] ? row[field?.name] : "-"}
                    </StyledTableCell>
                  )
              )}
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
